import { render, staticRenderFns } from "./customGridDropdown.vue?vue&type=template&id=127a36bc"
import script from "./customGridDropdown.vue?vue&type=script&lang=js"
export * from "./customGridDropdown.vue?vue&type=script&lang=js"
import style0 from "./customGridDropdown.vue?vue&type=style&index=0&id=127a36bc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports